import { Box } from '@mui/material';
import { PUBLIC_ASSETS_URLS } from '@/consts/common';

const Logo = () => (
  <Box
    component="img"
    alt="HealthConnect logo"
    src={PUBLIC_ASSETS_URLS.HEALTHCONNECT_LOGO_NEGATIVE}
    sx={{ height: '50px' }}
  />
);

export default Logo;
